import PropTypes from 'prop-types';
export const headingPropTypes = {
  heading: PropTypes.string
};